export enum Endpoints {
  AUTH = 'jwt-auth/v1/token/',
  CAREERS = 'wp/v2/careers',
  FORMS = 'contact-form-7/v1/contact-forms/',
  FRESHMAIL = 'freshmail/',
  GLOBALS = 'acf/v3/options/globals/',
  NOT_FOUND = 'acf/v3/options/notFound/',
  LANG = 'pll/v1/',
  PAGES = 'wp/v2/pages/',
  POSTS = 'wp/v2/posts/',
  SEARCH = 'wp/v2/search/',
  SETTINGS = 'wp/v2/settings/',
}
